export const buildReservationUrl = (post, dates, guestCount, guests) => {
  const baseUrl = `/posts/${post.slug}/reservations/select_date`
  const urlParams = new URLSearchParams()
  if (dates.length > 0) {
    const datesArray = dates.map(date => date.format('YYYY-MM-DD'))
    urlParams.set('dates', JSON.stringify(datesArray))
  }
  urlParams.set('guests', guestCount.toString())
  urlParams.set('guest_counts', JSON.stringify([guests.adults, guests.children, guests.infants]))

  return `${baseUrl}?${urlParams.toString()}`
}

const DANGEROUS_SCHEMES = ['javascript:', 'data:']

// JSや悪意のあるURLの埋め込みを防ぐ
export const getSafePath = (key: string, fallbackPath: string): string => {
  const raw = new URLSearchParams(window.location.search).get(key)
  if (!raw) {
    return fallbackPath
  }
  try {
    // エンコードされた危険スキームをデコード後に検出する
    const decoded = decodeURIComponent(raw)
    if (
      DANGEROUS_SCHEMES.some(scheme =>
        decoded
          .trim()
          .toLowerCase()
          .startsWith(scheme)
      )
    ) {
      return fallbackPath
    }
    const url = new URL(raw, window.location.origin)
    // 別オリジンのURLを防止
    if (url.origin !== window.location.origin) {
      return fallbackPath
    }
    const path = url.pathname + url.search + url.hash
    // プロトコル相対URL (//evil.com) やバックスラッシュ正規化 (/\evil.com) によるオープンリダイレクトを防止
    if (path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\')) {
      return path
    }
    return fallbackPath
  } catch {
    return fallbackPath
  }
}
